import ScrollMagic from 'scrollmagic';


$(document).ready(function () {
    $(this).scrollTop(0);
    parallaxImage();
    lazySizes.init();
    // $('.aspire').addClass('container');
    $("body, html").animate({
        scrollTop: 0
    }, '100');
    // match height
    $('.units .image-wrapper').matchHeight();
    $('.unit .image-wrapper').matchHeight();
    $('.house-models .unit--item').matchHeight();
    $('.house-model .unit--item').matchHeight();
    $('.construction-update .item-wrapper').matchHeight();
    $('#scrollTopBtn').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, '300');
    });

    // line animation
    $('.banner-wrapper .tagline').delay(300).addClass('active');


    $('.block-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // asNavFor: '.block-slider__nav',
        // nextArrow: $('.controler--block .arrow.right'),
        // prevArrow: $('.controler--block .arrow.left'),


    });
    $('.slick--main').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.slick--nav',
        // nextArrow: $('.controler--block .right'),
        // prevArrow: $('.controler--block .left'),

    });
    $('.slick--nav').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slick--main',
        focusOnSelect: true,
        // centerMode: true,
        arrows: true,
        nextArrow: $('.relative .arrow.right'),
        prevArrow: $('.relative .arrow.left'),
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        }]


    });
    $(".popup-gallery__wrapper").each(function () {
        $(this).magnificPopup({
            delegate: ".popup-image",
            type: "image",
            removalDelay: 300,
            mainClass: "mfp-fade",
            image: {
                // titleSrc: 'title'
                titleSrc: function (item) {
                    // console.log(item.el.parents('figure'));
                    return item.el.find('.item__watermark').html();
                }
            },
            gallery: {
                enabled: true
            }
        });
    });

    $("a.popup-image-s, a.popup-image-enlarge").magnificPopup({
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function (openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        },
        image: {
            // titleSrc: "title"
            titleSrc: function (item) {
                return item.el.parents('figure').find('p').html();
            }
        }
    });
    $("a.img-pop-up").magnificPopup({
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function (openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        },
        image: {
            // titleSrc: "title"
            titleSrc: function (item) {
                return item.el.find('.item__watermark').html();
            }
        }
    });
    // handle links with @href started with '#' only
    // $(document).on('click', 'a[href^="#"]', function(e) {
    //     // target element id
    //     var id = $(this).attr('href');

    //     // target element
    //     var $id = $(id);
    //     if ($id.length === 0) {
    //         return;
    //     }

    //     // prevent standard hash navigation (avoid blinking in IE)
    //     e.preventDefault();

    //     // top position relative to the document
    //     var pos = $id.offset().top;

    //     // animated top scrolling
    //     $('body, html').animate({scrollTop: pos});
    // });
    function goToByScroll(id) {
        // Reove "link" from the ID
        id = id.replace("-block", "");
        // Scroll

        if (id && $("#" + id).length) {
            $('html,body').animate({
                    scrollTop: $("#" + id).offset().top
                },
                'slow');
        }
        //   console.log("#"+id)

    }


    // $(".cancel-icon").click(function(e) {
    //     e.preventDefault();
    //     $(".cookies-wrapper").fadeOut(800, 0);
    //     localStorage.setItem("cookie_policy", true);
    // });
    $(".close-cp").click(function(e) {
        e.preventDefault();
        $(".cookies-wrapper").fadeOut(800, 0);
        $('body').removeClass('show-cookies');
        localStorage.setItem("cookie_policy", true);
    });
    if (localStorage.getItem("cookie_policy") == 'true') {
        $('.cookies-wrapper').hide();
        $('body').removeClass('show-cookies');
    }else{
        $('.cookies-wrapper').show();
        $('body').addClass('show-cookies');
    }


    $(".section--block__links > li > a").click(function (e) {
        // Prevent a page reload when a link is pressed
        e.preventDefault();
        // Call the scroll function
        goToByScroll($(this).attr("id"));

    });

    $('.dropdown-section--block__links .dropdown-menu > li > a').click(function (e) {
        e.preventDefault();
        goToByScroll($(this).attr("id"));
    })

    var jump = function (e) {
        if (e) {
            e.preventDefault();
            var target = $(this).attr("href");
        } else {
            var target = location.hash;
        }
        console.log(target)
        $('html,body').animate({
            scrollTop: $(target).offset().top
        }, 1000, function () {
            location.hash = target;
        });

    }


    if (location.hash) {
        setTimeout(function () {
            $('html, body').scrollTop(0).show();
            jump();
        }, 0);
    } else {
        $('html, body').show();
    }


    $('.advance-option').on('click', function () {
        //   console.log('yah')
        if ($('.search-action-area').hasClass('sp')) {
            $('.search-action-area').removeClass('sp');

        } else {
            $('.search-action-area').addClass('sp');

        }


    });
    $('.node-type-article .main__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: false,
        asNavFor: '.nav__slider',
        nextArrow: $('.node-type-projects .slick-arrow.right, .node-type-article .slick-arrow.right'),
        prevArrow: $('.node-type-projects .slick-arrow.left, .node-type-article .slick-arrow.left'),
      });
      $('.node-type-article .nav__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.main__slider',
        infinite: false,
        arrows: false,
        // dots: true,
        // centerMode: true,
        focusOnSelect: true
      });

});



$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $('.scrollbutton').show();
    } else {
        $('.scrollbutton').hide();

    }

    // line animation first block
    $('.intro .right-content').each(function () {

        var distance = $(this).offset().top;

        if ($(window).scrollTop() + $(window).outerHeight(true) - 400 >= distance) {
            $(this).addClass('active');
            // console.log(distance);
        }
    });
});

if ($('#borderHY').html() != undefined) {

    // midrise border
    var controller = new ScrollMagic.Controller();
    var tween = TweenMax.to("#border-left", 1, {height: "+=96%"})
    var scene = new ScrollMagic.Scene({triggerElement: "#trigger", triggerHook: 0.3, duration: 1000, reverse: false})
                                    .setTween(tween)
                                    // .addIndicators({name: "tween css class"})
                                    .addTo(controller)
                                    .on('start', function (event){
                                        tween.time(0)
                                    })
    // border-x
    var tweenX = new TweenMax.to("#border", 1, {right: "0px"})
    var sceneX = new ScrollMagic.Scene({triggerElement:"#triggerX", triggerHook: 0.6, duration: 10, reverse: false})
                                        .setTween(tweenX)
                                        // .addIndicators({name: "tween css class"})
                                        .addTo(controller)
                                        .on('start', function (event){
                                            tweenX.time(0);
                                        })

    // highrise animation
    var tweenHX = new TweenMax.to("#borderHX", 1, {left: "0px"})
    var sceneHX = new ScrollMagic.Scene({triggerElement:"#highriseX", triggerHook: 0.8, duration: 10, reverse: false})
                                        .setTween(tweenHX)
                                        // .addIndicators({name: "tween css class"})
                                        .addTo(controller)
                                        .on('start', function (event){
                                            tweenHX.time(0)
                                        })
    // highrise border Y
    var tweenHY = new TweenMax.to("#borderHY", 1, {height: "+=95%"})
    var sceneHY = new ScrollMagic.Scene({triggerElement: "#highriseY", triggerHook: 0.6, duration: 1000, reverse: false})
                                        .setTween(tweenHY)
                                        // .addIndicators({name: "tween css class"})
                                        .addTo(controller)
                                        .on('start', function (event){
                                            tweenHY.time(0)
                                        })

    // Homes animation
    var homeY = new TweenMax.to("#border-HY", 1, {height: "+=95%"})
    var homeSceneY = new ScrollMagic.Scene({triggerElement: "#homeY", triggerHook: 0.8, duration: "100%", reverse: false})
                                            .setTween(homeY)
                                            // .addIndicators({name: "tween css class"})
                                            .addTo(controller)
                                            .on('start', function (event){
                                                homeY.time(0)
                                            });
    var homeX = new TweenMax.to("#border-HX", 1, {right: "0px"});
    var homeSceneX = new ScrollMagic.Scene({triggerElement: "#homeY", triggerHook: 0.6, duration: 150, reverse: false})
                                            .setTween(homeX)
                                            // .addIndicators({name: "tween css class"})
                                            .addTo(controller)
                                            .on('start', function (event){
                                                homeX.time(0)
                                            });
    
}



$(window).on('scroll', function () {
    // parallaxImage();

});

function parallaxImage() {
    $('.parallax-element').each(function () {
        $this = $(this);
        $imgWidth = $this.find('img').outerWidth();
        $imgHeight = $this.find('img').outerHeight();
        // Just set the visibility of the image to hidden
        // in order to retain the height of the container
        $this.find('.img-parallax').css({
            background: "url('" + $this.find('img').attr('src') + "')",
            backgroundAttachment: 'scroll',
            // backgroundSize            : 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: $imgWidth + 300,
            height: $imgHeight + 500,
        });
        $this.find('img').css({
            'visibility': 'hidden',
        });
    });

    $('.img-parallax-vertical').each(function () {
        var img = $(this);
        var imgParent = $(this).parent();

        function parallaxImg() {
            var speed = img.data('speed');
            var imgY = imgParent.offset().top;
            var winY = $(this).scrollTop();
            var winH = $(this).height();
            var parentH = imgParent.innerHeight();


            // The next pixel to show on screen      
            var winBottom = winY + winH;

            // If block is shown on screen
            if (winBottom > imgY && winY < imgY + parentH) {
                // Number of pixels shown after block appear
                var imgBottom = ((winBottom - imgY) * speed);
                // Max number of pixels until block disappear
                var imgTop = winH + parentH;
                // Porcentage between start showing until disappearing
                var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
            }
            img.css({
                top: imgPercent + '%',
                transform: 'translate(-50%, -' + imgPercent + '%)'
            });
        }
        $(document).on({
            scroll: function () {
                parallaxImg();
            },
            ready: function () {
                parallaxImg();
            }
        });
    });

    $('.img-parallax-horizontal').each(function () {
        var img = $(this);
        var imgParent = $(this).parent();

        function parallaxImg() {
            var speed = img.data('speed');
            var imgX = imgParent.offset().top;
            var winX = $(this).scrollTop();
            var winH = $(this).height();
            var parentH = imgParent.innerHeight();


            // The next pixel to show on screen      
            var winBottom = winX + winH;

            // If block is shown on screen
            if (winBottom > imgX && winX < imgX + parentH) {
                // Number of pixels shown after block appear
                var imgBottom = ((winBottom - imgX) * speed);
                // Max number of pixels until block disappear
                var imgTop = winH + parentH;
                // Porcentage between start showing until disappearing
                var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
            }
            img.css({
                // top: imgPercent + '%',
                transform: 'translate(-' + imgPercent + '%,' + '0)'
            });
        }
        $(document).on({
            scroll: function () {
                parallaxImg();
            },
            ready: function () {
                parallaxImg();
            }
        });
    });

    $('.ads-slick-mutiple').slick({
        lazyLoad: 'ondemand',
        centerMode: true,
        slidesToShow: 1,
        centerPadding: '250px',
        infinite: true,
        draggable: true,
        speed: 400,
        autoplay: true,
        responsive: [
        {
        breakpoint: 1199,
        settings: {
            lazyLoad: 'ondemand',
            centerMode: true,
            slidesToShow: 3,
            centerPadding: '0',
            infinite: true,
            draggable: true,
            speed: 400,
            autoplay: true,
        }
    },
    {
    breakpoint: 768,
    settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        draggable: true,
        speed: 400,
        autoplay: true,
        centerPadding: '0px',
    }
    },
    {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      draggable: true,
      speed: 400,
      autoplay: true,
      centerPadding: '0px',
    }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
    });


}